import { Controller } from "@hotwired/stimulus"

// Compact search bar on /rentals results page.
// Renders a one-line summary (dates/guests/type) with a "Modify" button.
// Clicking Modify toggles open the full _campsite_search form inside a <details>.
export default class extends Controller {
  static targets = ["details"]

  toggle() {
    if (this.hasDetailsTarget) {
      this.detailsTarget.open = !this.detailsTarget.open
    }
  }
}
